export default function MortgageInsurance() {
  return (
    <div className="text-start container mt-3">
      <img
        src="../images/mortgage-insurance-header.jpg"
        alt="Contact Us"
        className="img-fluid mb-4"
        style={{ width: "100%", height: "600px" }}
      />
      <h1>Mortgage Insurance</h1>
      <div className="row align-items-center mt-4">
        <div className="col-md-6 justify-content-center d-flex">
          <img
            src="../images/mortgage-insurance.jpg" // Replace with the actual path to your logo
            alt="New Life Financial Services Logo"
            width="600"
            height="600"
            className="d-inline-block align-top me-2 bg-light  rounded-5"
          />
        </div>
        <div className="col-md-6">
          <p>
            This is a great breakdown of the key points when it comes to
            mortgage insurance and the differences between purchasing it from a
            lender versus a life insurance company. Here’s how I’d frame it to
            make the message a little smoother while keeping all the important
            details:
          </p>
          <h2 className="header">
            Protect Your Home, Protect Your Family: Understanding Mortgage
            Insurance
          </h2>

          <p>
            Buying a home is likely the biggest investment you’ll ever make.
            That's why it's essential to have the right mortgage insurance in
            place to protect your home, your family, and your financial future.
            Before you sign up for mortgage insurance through your bank or
            financial institution, take the time to sit down with us ,.New Life
            Financial Services Team offers a free, no-obligation consultation to
            help you understand your options and find the policy that offers the
            most protection.
          </p>
          <h2 className="header">
            Why Choose New Life Financial Services for Your Mortgage Insurance
            Needs?
          </h2>

          <p>
            As an expert in mortgage insurance, New Life Financial Services Team
            can help you navigate these differences and find a policy that
            aligns with your specific needs and budget. Whether you’re just
            starting your mortgage or looking to make sure your coverage is
            optimal, we can guide you through the process and help ensure you
            make the best choice for your family’s financial security. New Life
            Financial Services Team can help you navigate the advantages having
            life insurance mortgage protection over Lander mortgage insurance
            that aligns with your specific needs and budget.
          </p>
        </div>
      </div>
    </div>
  );
}
